"use client";

import { createContext, use, type ReactNode } from "react";
import { useSearchParams } from "next/navigation";

export type ListingQuery = Pick<URLSearchParams, "get" | "toString">;

const NO_QUERY: ListingQuery = new URLSearchParams();

const ListingQueryContext = createContext<ListingQuery>(NO_QUERY);

export function ListingQueryProvider({ children }: { children: ReactNode }) {
  const searchParams = useSearchParams();
  return (
    <ListingQueryContext value={searchParams}>
      {children}
    </ListingQueryContext>
  );
}

export function useListingQuery(): ListingQuery {
  return use(ListingQueryContext);
}
